import SkillsList from './SkillsList';

export default SkillsList;
